// Adapted from our own Immersive Worlds semantic vocabulary.
// Source: Juanmaes83/escaparates-pro
// labs/immersive-worlds/engine/schema/types.js
// blob beca133d6d2f950171c2b2c3f6bc6e744392e8d2

export const RECORD = Object.freeze({
  SPACE: 'SPACE',
  ANCHOR: 'ANCHOR',
  ENTITY: 'ENTITY',
  HOTSPOT: 'HOTSPOT',
  PORTAL: 'PORTAL',
  ROUTE: 'ROUTE'
});

export const SPACE_KIND = Object.freeze({
  WORLD: 'WORLD',
  DISTRICT: 'DISTRICT',
  PROPERTY: 'PROPERTY',
  PROPERTY_SPACE: 'PROPERTY_SPACE',
  SERVICE_CLUSTER: 'SERVICE_CLUSTER'
});

export const ENTITY_KIND = Object.freeze({
  PROPERTY: 'PROPERTY',
  PROPERTY_FEATURE: 'PROPERTY_FEATURE',
  CHARACTER: 'CHARACTER',
  INSTITUTION: 'INSTITUTION',
  SERVICE: 'SERVICE',
  AREA_GUIDE: 'AREA_GUIDE',
  LIFESTYLE: 'LIFESTYLE',
  MEDIA: 'MEDIA'
});

export const FICTION_STATUS = Object.freeze({
  FICTIONAL_WORLD: 'FICTIONAL_WORLD',
  ILLUSTRATIVE_COMPOSITE: 'ILLUSTRATIVE_COMPOSITE',
  REAL_VERIFIED: 'REAL_VERIFIED',
  AI_VISUALIZATION_DISCLOSED: 'AI_VISUALIZATION_DISCLOSED',
  UNVERIFIED_DRAFT: 'UNVERIFIED_DRAFT'
});

export const HOTSPOT_TYPE = Object.freeze({
  INFO: 'INFO',
  MEDIA: 'MEDIA',
  PORTAL: 'PORTAL',
  ACTION: 'ACTION',
  STORY: 'STORY',
  PROPERTY: 'PROPERTY',
  GUIDE: 'GUIDE'
});

export const ACTION = Object.freeze({
  FOCUS_ENTITY: 'FOCUS_ENTITY',
  RELEASE_FOCUS: 'RELEASE_FOCUS',
  OPEN_DETAIL: 'OPEN_DETAIL',
  PLAY_MEDIA: 'PLAY_MEDIA',
  ACTIVATE_PORTAL: 'ACTIVATE_PORTAL',
  START_ROUTE: 'START_ROUTE',
  SAVE_PROPERTY: 'SAVE_PROPERTY',
  REJECT_PROPERTY: 'REJECT_PROPERTY',
  ADD_TO_COMPARE: 'ADD_TO_COMPARE',
  REQUEST_VISIT: 'REQUEST_VISIT',
  ASK_SARAH: 'ASK_SARAH'
});

export const EXPERIENCE_MODE = Object.freeze({
  EXPLORE: 'EXPLORE',
  GUIDED: 'GUIDED',
  SEARCH: 'SEARCH',
  AUTHOR: 'AUTHOR'
});

// EXTENDED 2026-08-17 (Kimi K3): OVERVIEW/WALK/MAP added for the visual
// runtime camera-mode taxonomy (nightdrive-inspired). IW contract unchanged.
export const CAMERA_AUTHORITY = Object.freeze({
  EXPLORE: 'EXPLORE',
  OVERVIEW: 'OVERVIEW',
  WALK: 'WALK',
  MAP: 'MAP',
  FOCUS: 'FOCUS',
  DIRECTED: 'DIRECTED',
  AUTHOR: 'AUTHOR',
  TRANSITION: 'TRANSITION'
});

export const PROPERTY_STATE = Object.freeze({
  UNSEEN: 'UNSEEN',
  SEEN: 'SEEN',
  OPENED: 'OPENED',
  TOURED: 'TOURED',
  SHORTLISTED: 'SHORTLISTED',
  COMPARE: 'COMPARE',
  NEEDS_REVIEW: 'NEEDS_REVIEW',
  REJECTED: 'REJECTED',
  VISIT_REQUESTED: 'VISIT_REQUESTED',
  VISITED_REAL: 'VISITED_REAL',
  DECISION_PENDING: 'DECISION_PENDING'
});

export const SCHEMA_VERSION = 1;

export const CAMERA_LEAK_KEYS = Object.freeze([
  'camera', 'cameraPose', 'position', 'rotation', 'quaternion',
  'target', 'lookAt', 'fov', 'yaw', 'pitch', 'pose'
]);
